import DesignSimpleView from './DesignSimpleView'

export default DesignSimpleView
